enum StatusEmailEnum {
  Disponivel = 'Disponivel',
  EmUso = 'EmUso',
  Invalido = 'Invalido',
}

export default StatusEmailEnum
